import axiosInstance from "../axiosClient";
import { consultant, consultant_Active, getConsultantBalance, getConsultantUserRecharge, StatusConsultant, updateConsultant, updateConsultantAudio, userCreation } from "../config";


export const getConsultant = async (name,status,limit,start_key) => {
  let queryParams = [];
  if (status) queryParams.push(`approve_status=${encodeURIComponent(status)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`)
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.get(`${consultant}${queryString}`);
};
export const getConsultant_balance = async (name,limit,start_key) => {
  let queryParams = [];
  if (status) queryParams.push(`approve_status=${encodeURIComponent(status)}`);
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (limit) queryParams.push(`limit=${encodeURIComponent(limit)}`)
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.get(`${getConsultantBalance}${queryString}`);
};

  
export const update_consultant=  async(data) => {
  return await axiosInstance.patch(updateConsultant,data);
};

export const handleStatus = async(data)=>{
  let queryParams = [];
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return await axiosInstance.patch(`${StatusConsultant}${queryString}`,data)

}
export const handle_Active= async(data)=>{
  return await axiosInstance.patch(consultant_Active,data);
}


export const createConsultant = async (data) => {
  return await axiosInstance.post(userCreation,data);
};


export const handleUpdateAudioStatus=async(id,status)=>{
  let queryParams = [];
  if (status) queryParams.push(`status=${status}=${encodeURIComponent(status)}`);
  if (id) queryParams.push(`id=${encodeURIComponent(id)}`)
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.get(`${updateConsultantAudio}${queryString}`);
}


export const postConsultantUserRecharge = async (data) => {
  return await axiosInstance.post(getConsultantUserRecharge, data);
}